module.exports = __webpack_public_path__ + "img/part8.ef707cfd.png";